export const PurchaseOrderInformationFieldNames = {
  PONumber: 'PONumber',
} as const;

export type PurchaseOrderInformationFields = {
  [PurchaseOrderInformationFieldNames.PONumber]?: string;
};

export const PurchaseOrderFields: string[] = Object.values(
  PurchaseOrderInformationFieldNames,
);
